import { createSlice } from "@reduxjs/toolkit";

export const stopDiscoveryOrgSlice = createSlice({
  name: "onPremStopDiscoveryOrgDevices",
  initialState: {
    data: {},
  },
});

export default stopDiscoveryOrgSlice.reducer;